var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-mobile-shift-rows',{attrs:{"loading":Boolean(_vm.busy),"rows":_vm.cards,"stats":_vm.kpis,"search":_vm.searchText,"empty-icon":"mdi-bowl-mix-outline"}})
}
var staticRenderFns = []

export { render, staticRenderFns }